export enum QuoteType {
  All = 1,
  Regular = 2,
  Consigned = 3,
  NonExpired = 4
}
